export default __webpack_public_path__ + "static/media/preview.d164cc40.gif";